// extracted by mini-css-extract-plugin
export default {"list":"style_list__+1DeB","list1":"style_list1__RndWg"};